// CF-ONBOARDING-PREVIEW-V1 (PL #7696/#7698, 2026-06-04) + CF-FUNNEL-INSTANT-PLAY-V1 (PL #9263).
//
// Decides whether the first-run onboarding intro shows AUTOMATICALLY on app load.
// The Telegram deep-link `startapp=fresh` forces the intro (owner preview / replay) — a
// view-only override that changes NO stored state and is reusable on every fresh open.
//
// CF-FUNNEL-INSTANT-PLAY-V1: new users are NO LONGER auto-gated by the 3-slide carousel.
// Pre-game intro carousels tank first-session activation for ad-acquired traffic (0/10
// demo conversion observed on 金龙虎 AdsGram entrants — they bounce before reaching the
// free demo). New users now land directly on the playable game (demo FLIP ready). The
// intro is preserved, not deleted: the ⋯ "How it works" menu item re-shows it on demand
// (App sets showOnboarding=true directly), and `startapp=fresh` still forces it here on
// load. So auto-show depends ONLY on the fresh-preview deep link — not on any stored flag.
export function shouldShowOnboarding(
    startParam: string | null | undefined,
): boolean {
    return startParam === 'fresh';
}
